import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import PageHeading from '../ReusableComponents/PageHeading';
import DefaultButton from '../ReusableComponents/DefaultButton';
import InstitutionForm from './InstitutionForm';
import PortalConfiguration from '../PortalAluno/components/PortalConfiguration';
import { useMyOrganization } from './hooks';
import { ErrorNotice, Loading } from '../PortalAluno/components/Feedback';
import '../ReusableComponents/ModulePage.css';
import '../PortalAluno/portal.css';
export default function EditOrganization() {
  const { id } = useParams(),
    history = useHistory(),
    query = useMyOrganization(id),
    o = query.data;
  const backTo = id ? '/organizadoras' : '/minha-organizadora';
  return (
    <div className="module-page portal-admin">
      <section className="card module-card hidethis">
        <div className="card-body">
          <div className="portal-admin-row">
            <PageHeading
              title={id ? 'Editar organizadora' : 'Editar minha organizadora'}
              description="Atualize a identificação, os contatos e a identidade visual da organizadora."
              icon="organizations"
            />
            <DefaultButton text="Voltar" bg="secondary" to={backTo} />
          </div>
          {o && <p className="text-muted mb-0">{o.name}</p>}
        </div>
      </section>
      <ErrorNotice error={query.error} />
      {query.isLoading ? (
        <Loading />
      ) : (
        o && (
          <>
            <section className="card module-card module-content">
              <div className="card-body">
                <h2 className="module-details-title">Dados da organizadora</h2>
                {o.can_edit ? (
                  <InstitutionForm
                    organization={o}
                    organizationId={id}
                    backTo={backTo}
                    onSaved={() => history.push(id ? backTo : backTo + '?salvo=1')}
                  />
                ) : (
                  <div className="alert alert-warning">
                    Você não possui permissão para editar esta organizadora.
                  </div>
                )}
              </div>
            </section>
            {id && o.can_edit && <PortalConfiguration organizationId={id} />}
          </>
        )
      )}
    </div>
  );
}
